export const SILK_ROAD_REGIONS = [
  {
    slug: 'uzbekistan',
    image: 'https://images.pexels.com/photos/19439206/pexels-photo-19439206.jpeg?auto=compress&cs=tinysrgb&w=800',
    heroImage: 'https://images.pexels.com/photos/19439206/pexels-photo-19439206.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'kazakhstan',
    image: 'https://images.unsplash.com/photo-1751440355869-fe6673d79f7d?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1751440355869-fe6673d79f7d?w=1920&q=80',
  },
  {
    slug: 'kyrgyzstan',
    image: 'https://images.pexels.com/photos/35755650/pexels-photo-35755650.jpeg?auto=compress&cs=tinysrgb&w=800',
    heroImage: 'https://images.pexels.com/photos/35755650/pexels-photo-35755650.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'tajikistan',
    image: 'https://images.pexels.com/photos/30389854/pexels-photo-30389854.jpeg?auto=compress&cs=tinysrgb&w=800',
    heroImage: 'https://images.pexels.com/photos/30389854/pexels-photo-30389854.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'caucasus',
    image: 'https://images.pexels.com/photos/34954527/pexels-photo-34954527.jpeg?auto=compress&cs=tinysrgb&w=800',
    heroImage: 'https://images.pexels.com/photos/34954527/pexels-photo-34954527.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'iran',
    image: 'https://images.unsplash.com/photo-1624746068623-d3f9c4ce5739?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1624746068623-d3f9c4ce5739?w=1920&q=80',
  },
  {
    slug: 'turkey',
    image: 'https://images.unsplash.com/photo-1642447995041-436bb59b71f0?w=800&q=80',
    heroImage: 'https://images.unsplash.com/photo-1642447995041-436bb59b71f0?w=1920&q=80',
  },
];

export const getRegionBySlug = (slug) => SILK_ROAD_REGIONS.find(r => r.slug === slug);
export const getOtherRegions = (slug) => SILK_ROAD_REGIONS.filter(r => r.slug !== slug);
